export const panel = {
  details: 'details',
  login: 'login',
  registration: 'registration',
};
